import { SubdomainState } from './state';
import { subdomainInitialState } from './initial-state';
import { SubdomainActions } from './action-creators';
import * as actions from './actions';

export const subdomainReducer = (state: SubdomainState = subdomainInitialState, action: SubdomainActions): SubdomainState => {
  switch (action.type) {

    case actions.GET_SUBDOMAIN: {
      return {
        ...state,
        currentSubdomain: undefined
      };
    }

    case actions.GET_SUBDOMAIN_SUCCESS: {
      return {
        ...state,
        currentSubdomain: action.subdomain
      }
    }

    case actions.UPDATE_SUBDOMAIN_SUCCESS: {
      return {
        ...state,
        currentSubdomain: action.subdomain
      }
    }

    case actions.QUERY_SUBDOMAIN: {
      return {
        ...state,
        query: undefined
      }
    }

    case actions.QUERY_SUBDOMAIN_SUCCESS: {
      return {
        ...state,
        query: action.subdomain
      }
    }
    
    default: {
      return { ...state };
    }
  }
}